import * as Yup from "yup";

export const IngCreditRequestSchema = Yup.object().shape({
	reasonCredit: Yup.string().required("Veuillez renseigner une raison"),
})
